module.exports = __webpack_public_path__ + "img/rimg2.fef31ab1.png";